<template>
    <div class="flex w-24 justify-center">
        <div
            :class="[
                isActiveRoute ? 'router-link-active' : '',
                'LeftNavItem relative inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center overflow-visible rounded-lg',
            ]"
            @click.stop="navigate"
        >
            <span
                :class="{
                    'pointer-events-none -translate-x-3 opacity-0 duration-200': !isExpanded,
                    'pointer-events-auto opacity-100 duration-500': isExpanded,
                }"
                class="title absolute top-0 bottom-0 left-24 -ml-14 flex w-64 items-center pl-3 text-sm font-medium transition-all ease-out"
                >{{ item.title }}
                <span @click.stop>
                    <slot name="expander" />
                </span>
            </span>
            <span class="inline-flex h-6 w-6" aria-hidden="true">
                <slot />
            </span>
        </div>
    </div>
</template>
<script setup>
import { computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
    isExpanded: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['active-route-change'])

const router = useRouter()
const currentRoute = useRoute()

const isActiveRoute = computed(() => {
    const to = props.item.to

    if (to && typeof to === 'object' && to.name) {
        // For named routes (e.g. { name: 'signal-index' }), match the exact route
        // OR any nested route under the same section (e.g. 'signal-builder', 'signal-results').
        // We derive the prefix by stripping the trailing '-index' suffix.
        const prefix = to.name.replace(/-index$/, '-')
        return Boolean(
            currentRoute?.matched?.find((route) => {
                const name = String(route.name ?? '')
                return name === to.name || name.startsWith(prefix)
            })
        )
    }

    // For plain string paths just match against the route tree directly.
    return Boolean(currentRoute?.matched?.find((route) => route.path === to))
})

watch(
    () => isActiveRoute.value,
    () => {
        emit('active-route-change', isActiveRoute.value)
    }
)

onMounted(() => {
    if (isActiveRoute.value) {
        emit('active-route-change', isActiveRoute.value)
    }
})

function navigate() {
    router.push(props.item.to)
}
</script>

<style scoped>
@reference "@/tailwind.css";
.LeftNavItem {
    @apply text-slate-400 hover:bg-slate-50 hover:text-slate-600;
}
.LeftNavItem .title {
    @apply text-slate-500;
}
.LeftNavItem:hover .title {
    @apply text-slate-700;
}

.LeftNavItem.router-link-active {
    @apply bg-brand-blue-50 text-brand-blue-700;
}
.LeftNavItem.router-link-active .title {
    @apply text-brand-blue-800;
}
</style>
